<template>
    <v-sheet v-if="!(mode == 'view' && !items.length)">
        <div class="d-flex align-center" style="position: relative">
            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
                보유 자격증 및 공인 어학성적
                <!-- <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">자격증 작성시 더 좋은 일자리를 구할 수 있습니다.</span> -->
            </h5>
        </div>

        <v-sheet>
            <v-divider class="primary border-2" />
            <v-data-table v-bind="{ items, headers }" :items-per-page="-1" hide-default-footer disable-sort disable-filtering :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm">
                <template #[`item.name`]="{ item, value }">
                    <template v-if="mode == 'form'">
                        <v-text-field v-model="item.name" v-bind="attrs_input" @input="emit" />
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ value || "-" }}</p>
                    </template>
                </template>
                <template #[`item.desc`]="{ item, value }">
                    <template v-if="mode == 'form'">
                        <v-text-field v-model="item.desc" v-bind="attrs_input" @input="emit" />
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ value || "-" }}</p>
                    </template>
                </template>
                <template #[`item.issuer`]="{ item, value }">
                    <template v-if="mode == 'form'">
                        <v-text-field v-model="item.issuer" v-bind="attrs_input" @input="emit" />
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ value || "-" }}</p>
                    </template>
                </template>
                <template #[`item.issuedAt`]="{ item, value }">
                    <template v-if="mode == 'form'">
                        <v-date-field v-model="item.issuedAt" v-bind="attrs_input" @input="emit" />
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ value?.toDate?.() || value || "- " }}</p>
                    </template>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn icon x-small class="u-pink mx-auto" @click="remove(item)"><i class="icon icon-minus" /></v-btn>
                    <!-- <v-btn icon color="grey-f8" class="v-btn--minus mx-auto" @click="remove(item)"> <v-icon>mdi-minus</v-icon> </v-btn> -->
                    <!-- <template v-if="$vuetify.breakpoint.mdAndUp">
                        <v-btn block text icon @click="remove(item)">
                            <v-icon large color="red lighten-4">mdi-minus-circle</v-icon>
                        </v-btn>
                    </template>
                    <template v-else>
                        <v-btn block color="red lighten-5" @click="remove(item)">
                            <v-icon large color="red lighten-4">mdi-minus-circle</v-icon>
                        </v-btn>
                    </template> -->
                </template>
                <template #footer>
                    <v-divider />
                    <template v-if="mode == 'form'">
                        <v-btn block color="grey-f8" class="v-btn--plus rounded-lg" @click="addItem"> <i class="icon icon-plus-sm" /> </v-btn>
                    </template>
                </template>
            </v-data-table>
        </v-sheet>
    </v-sheet>
</template>

<script>
import { attrs_input, initOfficeSkillItem, initResume, OFFICE_SKILL_TYPES } from "@/assets/variables";

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

const types = Object.values(OFFICE_SKILL_TYPES);

export default {
    components: {
        VDateField,
    },
    props: {
        value: { type: Object, default: initResume }, // resume
        mode: { type: String, default: "form" },
    },
    data: () => ({
        resume: initResume(),

        types,
        attrs_input,
        OFFICE_SKILL_TYPES,
    }),
    computed: {
        items() {
            return this.resume.certifications;
        },
        headers() {
            const headers = [];
            headers.push({ text: "자격증/공인시험 이름", value: "name" });
            headers.push({ text: "등급/점수", value: "desc" });
            headers.push({ text: "발행기관", value: "issuer" });
            headers.push({ text: "발행일", value: "issuedAt" });
            if (this.mode == "form") headers.push({ width: +80, text: "", value: "actions" });
            return headers.map((item) => ({ ...item, align: item.align || "center", cellClass: `${item.cellClass || ""} pa-16` }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(this.value) };
        },
        emit() {
            let { certifications } = this.resume;
            this.$emit("input", { ...this.value, certifications });
        },
        addItem() {
            this.resume.certifications.push({ ...initOfficeSkillItem(), tempId: Math.random() });
            this.emit();
        },
        remove(item) {
            this.resume.certifications = this.resume.certifications.filter(({ tempId }) => tempId != item.tempId);
            this.emit();
        },
        onChangeType(type, item) {
            switch (type) {
                case OFFICE_SKILL_TYPES.ANOTHER.value: {
                    item.name = null;
                    break;
                }
                default: {
                    item.name = OFFICE_SKILL_TYPES[type]?.text;
                    break;
                }
            }
            this.emit();
        },
        getNameText({ type, name } = {}) {
            let text = OFFICE_SKILL_TYPES[type]?.text || "";
            if (type == OFFICE_SKILL_TYPES.ANOTHER.value) {
                if (text) text += " / ";
                text += name || "";
            }
            return text;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-data-table__mobile-row {
        height: auto !important;
        display: block;
        border-bottom: 1px solid var(--border-color);
        padding: 10px !important;
    }
    .v-data-table__mobile-row__cell {
        width: 100%;
    }
    .v-data-table__mobile-row__header {
        margin-bottom: 6px;
    }

    .v-data-table__wrapper {
        overflow: initial;
    }
}
</style>
